module.exports = __webpack_public_path__ + "static/img/image4.5292f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/image4.png
// module id = sgPu
// module chunks = 0